import type { GlobalOnexConfig, OnexConfig } from '@otto-ec/eprivacy-onex'
import { ActiveOnexConfigAdapter, onexAssignmentsAdapter } from '../adapters'
import { logger } from './logger'
import { environmentConfig } from './environment.config'

export type { OnexConfig } from '@otto-ec/eprivacy-onex'
export type { ActiveOnexConfigPort } from '../ports'

export async function activeVariantConfig(): Promise<OnexConfig> {
  const activeOnex = new ActiveOnexConfigAdapter(
    logger,
    onexAssignmentsAdapter,
    await loadOnexConfig()
  )
  return activeOnex.activeOnexConfig()
}

async function loadOnexConfig(): Promise<GlobalOnexConfig> {
  return (
    environmentConfig.stage === 'live'
      ? await import('../../../../onex-config')
      : await import('../../../../onex-config.nonlive')
  ).config
}
